export const AUTHENTICATION_SUCCESS = "AUTHENTICATION_SUCCESS";
export const AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";

export const ADMIN_SUCCESS = "ADMIN_SUCCESS";
export const ADMIN_FAILED = "ADMIN_FAILED";

export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const UPDATE_SECONDARY_ACCOUNT = "UPDATE_SECONDARY_ACCOUNT";
export const DELETE_SECONDARY_ACCOUNT = "DELETE_SECONDARY_ACCOUNT";
export const UPDATE_ACCOUNT_VARIABLE = "UPDATE_ACCOUNT_VARIABLE";
